import { Box, Button, Text, Title, VStack } from "@repo/ui";
import { useTheme } from "@repo/tokens";
import React from "react";
import { ROUTESWEB } from "@repo/utils";

type Props = {
  children: React.ReactNode;
};

type State = {
  error: Error | null;
};

export class SelfLearnModuleErrorBoundary extends React.Component<
  Props,
  State
> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      return <SelfLearnModuleErrorFallback error={this.state.error} />;
    }
    return this.props.children;
  }
}

const SelfLearnModuleErrorFallback = ({ error }: { error: Error }) => {
  const { theme } = useTheme();
  return (
    <Box
      style={{
        flex: 1,
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.surface.page,
        padding: 16,
      }}
    >
      <VStack gap="l" align="center" style={{ maxWidth: 520 }}>
        <Title variant="h2">Something went wrong</Title>
        <Text color="text.secondary" style={{ textAlign: "center" }}>
          {error.message || "Unknown error"}
        </Text>
        <Button
          variant="primary"
          onPress={() => {
            window.location.href = `/${ROUTESWEB.APP.SELF_LEARN}`;
          }}
        >
          Go to Self Learn
        </Button>
      </VStack>
    </Box>
  );
};
